module.exports = __webpack_public_path__ + "assets/img/icon-tuxiang-d6c92d09.png";